import React, { forwardRef } from 'react';
import { SvgIconProps } from '@mui/material/SvgIcon';
import { CheckCircleIcon } from './CheckCircleIcon';

interface SuccessCheckCircleIconProps extends SvgIconProps {
  backgroundColor?: string;
}

export const SuccessCheckCircleIcon = forwardRef<SVGSVGElement, SuccessCheckCircleIconProps>((props, ref) => {
  return <CheckCircleIcon htmlColor="#ffffff" backgroundColor="primary" {...props} ref={ref} />;
});
